import React, { useEffect, useState } from 'react';
import { apiRequest } from "../services/api";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router-dom';
import EnquiryModal from './EnquiryModal';

const Packages = () => {

    const [data, setData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        window.dispatchEvent(new Event('resize'));
        apiRequest({ url: "/packages" })
            .then((res) => {
                if (res.success && Array.isArray(res.data)) {
                    setData(res.data);
                } else {
                    console.warn("Unexpected response format:", res);
                }
            })
            .catch((err) => {
                console.error("Error loading hero slides:", err.message);
            });
    }, []);

    const sliderSettings = {
        dots: true,
        infinite: data.length > 1,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 992,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1 }
            }
        ]
    };

    return (
        <>
            <div className="container-fluid packages py-5" style={{ width: '100%' }}>
                <div className="container py-5">
                    <div className="mx-auto text-center mb-5"   >
                        <h5 className="section-title px-3">Packages</h5>
                        <h1 className="mb-0">Customized Holidays</h1>
                    </div>

                    <Slider {...sliderSettings}>
                        {data.map((item, index) => (
                            <div className="packages-item px-3" key={index}>
                                <div className="packages-img position-relative">
                                    <img
                                        src={item.img}
                                        className="img-fluid w-100 rounded-top"
                                        alt="Image"
                                    />
                                    <div
                                        className="packages-info d-flex border border-start-0 border-end-0 position-absolute"
                                        style={{ width: "100%", bottom: 0, left: 0, zIndex: 5 }}
                                    >

                                        {item.city && (
                                            <small className="flex-fill text-center border-end py-2">
                                                <i className="fa fa-map-marker-alt me-2"></i>
                                                {item.city}
                                            </small>
                                        )}

                                        {item.duration && (
                                            <small className="flex-fill text-center border-end py-2">
                                                <i className="fa fa-calendar-alt me-2"></i>
                                                {item.duration}
                                            </small>
                                        )}

                                        {item.persons && (
                                            <small className="flex-fill text-center py-2">
                                                <i className="fa fa-user me-2"></i>
                                                {item.persons}
                                            </small>
                                        )}
                                    </div>
                                    <div className="packages-price py-2 px-4">{item.price}</div>
                                </div>
                                <div className="packages-content bg-light">
                                    <div className="p-3">
                                        <h5>{item.destination}</h5>
                                        {/* <small className="text-uppercase">Hotel Deals</small>
                                        <div className="mb-3">
                                            <small className="fa fa-star text-primary"></small>
                                            <small className="fa fa-star text-primary"></small>
                                            <small className="fa fa-star text-primary"></small>
                                            <small className="fa fa-star text-primary"></small>
                                            <small className="fa fa-star text-primary"></small>
                                        </div> */}
                                        <p className="mb-2">{item.short_section}</p>
                                    </div>
                                    <div className="row bg-primary rounded-bottom mx-0">
                                        <div className="col-6 text-start px-0">
                                            <Link to={`/package-details/${item.id}`} className=" btn text-white py-2 px-4">
                                                Read More
                                            </Link>
                                        </div>
                                        <div className="col-6 text-end px-0">
                                            <a onClick={() => setModalOpen(true)} className=" btn text-white py-2 px-4">
                                                Enquiry now
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                    <EnquiryModal isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} />
                </div>
            </div>
        </>
    );
};

export default Packages;
